module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-card', {
    staticClass: "elevation-0"
  }, [_c('v-card-title', {
    staticClass: "title"
  }, [_c('span', {
    staticStyle: {
      "color": "gray"
    }
  }, [_vm._v("Никнейм: ")]), _vm._v(" " + _vm._s(_vm.$route.params.nickname) + "     "), _c('span', {
    staticStyle: {
      "color": "gray"
    }
  }, [_vm._v("UID:  ")]), _vm._v(" " + _vm._s(_vm.$route.params.id) + "\n          "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "grey",
    attrs: {
      "fab": "",
      "small": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.exit($event)
      }
    }
  }, [_c('v-icon', [_vm._v("cancel")])], 1)], 1), _vm._v(" "), (_vm.loading !== true) ? _c('v-card-text', [
    [_c('table', [_c('tr', {
      staticStyle: {
        "vertical-align": "top",
        "text-align": "left"
      }
    }, [_c('td', [_vm._v("\n            Дней аккаунту: "), _c('b', [_vm._v(_vm._s(_vm.customer.accountceate_days != 'null' ? _vm.customer.accountceate_days : ''))]), _c('br'), _vm._v("\n            Дней с первой сделки: "), _c('b', [_vm._v(_vm._s(_vm.customer.first_trade_days != 'null' ? _vm.customer.first_trade_days : ''))]), _c('br'), _vm._v("\n            Общий торговый объем: "), _c('b', [_vm._v(_vm._s(_vm.customer.total_trade_amount != 'null' ? Math.round(_vm.customer.total_trade_amount) : ''))]), _c('br'), _vm._v("\n            Ордеров продажа: "), _c('b', [_vm._v(_vm._s(_vm.customer.total_finish_sell_count != 'null' ? _vm.customer.total_finish_sell_count : ''))]), _c('br'), _vm._v("\n            Ордеров покупка: "), _c('b', [_vm._v(_vm._s(_vm.customer.total_finish_buy_count != 'null' ? _vm.customer.total_finish_buy_count : ''))]), _c('br'), _vm._v("\n            Страна верификации: "), _c('b', [_vm._v(_vm._s(_vm.customer.kyc_country_code != 'null' ? _vm.customer.kyc_country_code : ''))]), _c('br'), _vm._v("\n            Положительные отзывы: "), _c('b', [_vm._v(_vm._s(_vm.customer.good_appraise_count != 'null' ? _vm.customer.good_appraise_count : ''))]), _c('br'), _vm._v("\n            Негативные отзывы: "), _c('b', [_vm._v(_vm._s(_vm.customer.bad_appraise_count != 'null' ? _vm.customer.bad_appraise_count : ''))]), _c('br'), _vm._v("\n            Рейтинг: "), _c('b', [_vm._v(_vm._s(_vm.customer.good_appraise_rate != 'null' ? _vm.customer.good_appraise_rate : ''))]), _c('br'), _vm._v("\n            E-mail: "), _c('b', [_vm._v(_vm._s(_vm.customer.email != 'null' ? _vm.customer.email : ''))]), _c('br'), _vm._v("\n            Телефон: "), _c('b', [_vm._v(_vm._s(_vm.customer.mobile != 'null' ? _vm.customer.mobile : ''))]), _c('br'), _vm._v("\n            Рейтинг за 30 дней: "), _c('b', [_vm._v(_vm._s(_vm.customer.recent_rate != 'null' ? _vm.customer.recent_rate : ''))]), _c('br'), _vm._v("\n            Ордеров за 30 дней: "), _c('b', [_vm._v(_vm._s(_vm.customer.recent_finish_count != 'null' ? _vm.customer.recent_finish_count : ''))]), _c('br'), _vm._v("\n            Среднее время оплаты: "), _c('b', [_vm._v(_vm._s(_vm.customer.average_release_time != 'null' ? _vm.customer.average_release_time : ''))]), _c('br'), _vm._v("\n            Среднее время перевода: "), _c('b', [_vm._v(_vm._s(_vm.customer.average_transfer_time != 'null' ? _vm.customer.average_transfer_time : ''))]), _c('br'), _vm._v("\n            Торговый объем за 30 дней: "), _c('b', [_vm._v(_vm._s(_vm.customer.recent_trade_amount != 'null' ? _vm.customer.recent_trade_amount : ''))]), _c('br'), _vm._v("\n            Дата создания аккаунта: "), _c('b', [_vm._v(_vm._s(_vm.customer.register_time != 'null' ? _vm.time(_vm.customer.register_time) : ''))]), _c('br'), _vm._v("\n            Имя: "), _c('b', [_vm._v(_vm._s(_vm.customer.real_name_en != 'null' ? _vm.customer.real_name_en : ''))]), _c('br'), _vm._v("\n            Добавлен: "), _c('b', [_vm._v(_vm._s(_vm.customer.timestamp))]), _c('br')]), _vm._v(" "), _c('td'), _c('td', [_vm._v("     ")]), _vm._v("\n            Контакты:"), _c('br'), _vm._v(" "), _c('span', _vm._l((JSON.parse(_vm.customer.contacts)), function(header, index) {
      return _c('div', {
        key: header.text
      }, [_c('b', [_vm._v(_vm._s(index))]), _vm._v(" " + _vm._s(_vm.time(header)) + "\n                  ")])
    })), _vm._v(" "), _c('td', [_vm._v("            ")]), _vm._v(" "), _c('td', [_vm._v("\n            Последние ордера контрагента:"), _c('br'), _vm._v(" "), _vm._l((_vm.orders.orders), function(order, index) {
      return _c('tr', {
        key: order.text
      }, [_c('td', {
        staticStyle: {
          "vertical-align": "middle"
        }
      }, [_vm._v(" " + _vm._s(order.status == 50 ? '✅' : order.status < 30 ? '⏳' : order.status == 30 ? '🙏' : '❌'))]), _vm._v(" "), _c('td', {
        style: (order.side == 0 ? 'color: green;' : 'color: red;')
      }, [_vm._v("   " + _vm._s(_vm.time(order.createDate / 1000)) + " ")]), _vm._v(" "), _c('td', [_vm._v("   " + _vm._s(order.amount) + " ")]), _vm._v(" "), _c('td', [_vm._v("   " + _vm._s(order.currencyId) + " ")]), _vm._v(" "), _c('td', [_vm._v("   " + _vm._s(order.userName) + " ")])])
    })], 2), _vm._v("            \n          "), _c('td', [(_vm.blacklist.customer.length > 0) ? _c('div', [_vm._v("Блекслист телеграмм:\n            "), _vm._l((_vm.blacklist.customer), function(report, index) {
      return _c('tr', [_c('td', {
        staticStyle: {
          "max-width": "100px"
        }
      }, [_vm._v("   "), _c('b', [_vm._v(_vm._s(report.timestamp))])]), _vm._v(" "), _c('td', {
        staticStyle: {
          "max-width": "300px"
        }
      }, [_vm._v("   " + _vm._s(report.message) + " ")])])
    }), _c('br')], 2) : _vm._e(), _vm._v(" "), (_vm.sources.appraises.length > 0) ? _c('div', [_vm._v("Отзывы из других источников:\n            "), _vm._l((_vm.sources.appraises), function(report, index) {
      return _c('tr', [_c('td', {
        staticStyle: {
          "max-width": "90px"
        }
      }, [_vm._v("   "), _c('b', [_vm._v(_vm._s(_vm.timestampToDate(report.timestamp)))])]), _vm._v(" "), _c('td', {
        staticStyle: {
          "max-width": "300px",
          "overflow-wrap": "break-word"
        }
      }, [_vm._v("   " + _vm._s(report.feedback_text) + "    " + _vm._s(report.from_username) + " ")])])
    })], 2) : _vm._e(), _vm._v(" "), (_vm.appraises.appraises.length > 0) ? _c('div', [_vm._v("Негативные отзывы Байбит:\n            "), _vm._l((_vm.appraises.appraises), function(report, index) {
      return _c('tr', [_c('td', {
        staticStyle: {
          "max-width": "90px"
        }
      }, [_vm._v("   "), _c('b', [_vm._v(_vm._s(report.timestamp))])]), _vm._v(" "), _c('td', {
        staticStyle: {
          "max-width": "300px",
          "overflow-wrap": "break-word"
        }
      }, [_vm._v("   " + _vm._s(report.message) + "    " + _vm._s(report.nick_name) + " ")])])
    })], 2) : _vm._e()])])])]
  ], 2) : _vm._e(), _vm._v(" "), (_vm.loading !== true) ? _c('v-card-text', [_vm._v("\n          " + _vm._s(_vm.link) + " "), _c('br'), _c('br')]) : _vm._e()], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// /Users/gtirby/develop/~/vue-loader/lib/template-compiler?{"id":"data-v-675baa3a","hasScoped":true}!/Users/gtirby/develop/~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/ContragentForm.vue
// module id = 418
// module chunks = 0